<template lang="pug">
  footer.footer(style="background-color:#373A3C")
    b-container
      b-row.copyright
        b-col
          ul.text-center(style="-webkit-padding-start: 10px")
            li
              p &copy; Copyright 2018 - {{year}} - Pedido Web - Todos os direitos reservados
            li
              p Desenvolvido por
                a(href="https://wwww.labcinco.com", target="_blank" style="color:#FFF; margin-left:5px;") Lab Cinco
</template>
<script>

export default {
  data () {
    return {
      year: this.$moment().year()
    };
  }
};
</script>


<style lang="scss" scoped>
footer{
  padding-top: 15px;
  padding-bottom: 15px;
  height: auto;
  // position: fixed;
  width: 100%;
  bottom: 0;
  b-container {
    min-height: auto;
    justify-content: center;
    align-items: center;
    text-align: center;
    display: inherit;
  }
  ul{
    list-style-type: none;
    text-align: left;
  }
  p{
    font-style: italic;
    font-weight: 600;
    color:#FFF;
    font-size: 14px;
  }
  .titulo{
    padding-top: 0px;
    p{
      font-weight: 600;
      font-size: 17px;
      color:#FFF;
    }
  }
  .copyright{
    padding-top: 30px;
    p{
      font-style: normal;
      font-weight: 200;
      margin-bottom: 0px;
      color:#FFF;
      font-size: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue